import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import {validateEmailRegEx, validatePhoneNumber} from "../Shared/FormField";
import {t} from "i18next";
import DeviceWidget from "../FormComponents/DeviceWidget/DeviceWidget";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { InertiaLink } from "@inertiajs/inertia-react";
import MuiPhoneNumber from "material-ui-phone-number";

const validProblem = (values) => {
    return values.problem_1 && values.problem_2 || values.problem_1 === 'other' && values.problem_description;
};

export const orderEntryConfigAmazonNonPaid = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "enableStepper": false,
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect"
                },
            ],
        },
        {
            "hideFromStepper": true,
            "showSteps": false,
            // "description": <Trans i18nKey={"orderEntry.description"}>Your device is not behaving as you expect? <a href={"https://b2x.com/"} title={'B2X'} target={'_blank'}>B2X</a> support you from here to provide a solution quickly. Please complete the form below and we will get back to you to resolve the situation.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                    <div className={'mt-3'}></div>
                    </>,
                },
                {
                    "component": "serialnumber",
                    "size": "full",
                    "required": true,
                    "validateSerialNumber": value => (/^.{16}$/.test(value) ? undefined : <Trans i18nKey="serialNumber.write16chars">You have to provide exactly 16 characters</Trans>),
                    "uppercase": true,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <div className={'flex justify-center mt-6'}>
                            <div className={'p-6 max-w-2xl b2x-shadow-md rounded-lg mt-3 flex flex-col justify-center items-center gap-1 bg-red-100 text-center'}>
                                <h3 className={'font-bold text-lg m-0'}>
                                    <Trans i18nKey="serialNumber.noOrderFound">No existing order with this serialnumber was found.</Trans>
                                </h3>
                            </div>
                        </div>
                    </>,
                    "conditionFunction": (values, orderEntryState) => {
                        return values.requesttype && orderEntryState?.serialNumber?.openOrders?.length === 0;
                    },
                },
            ],
            "id": "serialnumber",
        },
        {
            "heading": <Trans i18nKey="serialNumber.problemCategory">Problem category</Trans>,
            "description": <Trans i18nKey="orderEntry.problemDescription.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "problem_description",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.problem.heading'}>What happend?</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "problemselectbig",
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3><Trans i18nKey={'orderEntry.uploadProblemImage'}>Upload Pictures of Defect</Trans></h3>
                        <p><Trans i18nKey={'orderEntry.uploadProblemImage.description'}>Please upload pictures showing the defects. You can upload JPG, PNG or PDF files up to 20 MB size.</Trans></p>
                    </>,
                    "conditionFunction": values => values.requesttype && validProblem(values),
                },
                {
                    "size": "full",
                    "component": "dropzoneform",
                    "conditionFunction": values => values.requesttype && validProblem(values),
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                return values.requesttype && orderEntryState?.serialNumber?.product && orderEntryState?.serialNumber?.openOrders?.length > 0;
            },
        },
        {
            "heading": t('orderEntry.addressContact'),
            "description": <Trans i18nKey="orderEntry.addressContact.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "address",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.addressContact.long'}>Contact and Address Details</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3 style={{ marginBottom: 0}}><Trans i18nKey={'queueDetail.contact'}>Contact</Trans></h3>
                    </>,
                },
                {
                    "name": "name",
                    "label": <Trans i18nKey="orderEntry.addressContact.enduserName">Name</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.enduserName">Name</Trans>,
                    "size": "full",
                    "type": "text",
                    "required": true,
                },
                {
                    "name": "email",
                    "label": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
                    "size": "half",
                    "type": "email",
                    "required": true,
                },
                {
                    "name": "phone",
                    "label": <Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.phoneNumber">Phone number</Trans>,
                    "size": "half",
                    "type": "phoneinput",
                    "required": true,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3 style={{ marginBottom: 0}}><Trans i18nKey={'queueDetail.address'}>Address</Trans></h3>
                    </>,
                },
                {
                    "size": "full",
                    "component": "addressautocomplete"
                },
                {
                    "name": "zip",
                    "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
                    "size": "half",
                    "required": true,
                },
                {
                    "name": "city",
                    "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
                    "size": "half",
                    "required": true,
                },
                {
                    "name": "country_id",
                    "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
                    "size": "half",
                    "type": "select",
                    "options": [
                        {
                            "value": "de",
                            "label": <Trans i18nKey="orderEntry.addressContact.germany">Germany</Trans>
                        },
                        {
                            "value": "ch",
                            "label": <Trans i18nKey="orderEntry.addressContact.switzerland">Switzerland</Trans>
                        }
                    ],
                    "required": true,
                },
                {
                    "name": "deviating_invoice_address",
                    "label": <Trans i18nKey="orderEntry.deviating_invoice_address">Different billing address</Trans>,
                    "size": "full",
                    "type": "checkbox",
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3><Trans i18nKey={'orderEntry.invoice_address'}>Billing address</Trans></h3>
                        <p><Trans i18nKey={'orderEntry.invoice_address.description'}>Please fill in the address that will be displayed on the invoice.</Trans></p>
                    </>,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "name": "invoice_name",
                    "label": <Trans i18nKey="orderEntry.addressContact.name">Name</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.name">Name</Trans>,
                    "size": "full",
                    "type": "text",
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "size": "full",
                    "component": "addressautocomplete",
                    "prefix_name": "invoice_",
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "name": "invoice_zip",
                    "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
                    "size": "half",
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "name": "invoice_city",
                    "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
                    "size": "half",
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "name": "invoice_country_id",
                    "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
                    "size": "half",
                    "type": "select",
                    "options": [
                        {
                            "value": "de",
                            "label": <Trans i18nKey="orderEntry.addressContact.germany">Germany</Trans>
                        },
                        {
                            "value": "ch",
                            "label": <Trans i18nKey="orderEntry.addressContact.switzerland">Switzerland</Trans>
                        }
                    ],
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                return values.requesttype && orderEntryState?.serialNumber?.product && validProblem(values) && orderEntryState?.serialNumber?.openOrders?.length > 0;
            },
        },
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validAddress = values.name && values.city && validateEmailRegEx.test(values.email) && validatePhoneNumber.test(values.phone) && values.street && values.housenumber && values.zip && values.country_id;

                        return validAddress && validProblem(values) && orderEntryState?.serialNumber?.openOrders?.length > 0;
                    }
                }
            ]
        }
    ]
}
